<template>
  <div class="flex w-full">
    <span
      v-if="!editing"
      class="flex-grow"
    >{{ options[form[attribute]] }}</span>

    <form
      v-if="editing"
      class="flex justify-between-my-2 items-start w-full"
      @submit.prevent="save"
    >
      <div class="flex flex-col flex-grow">
        <select
          :id="attribute"
          v-model="form[attribute]"
          class="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
        >
          <option
            v-for="(value, id) in options"
            :value="id"
          >
            {{ value }}
          </option>
        </select>
        <jet-input-error
          :message="form.errors[attribute]"
          class="mt-2"
        />
      </div>
      <div class="flex flex-shrink items-center">
        <button
          :class="{ 'opacity-25': form.processing }"
          :disabled="form.processing"
          type="button"
          class="font-medium text-gray-600 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500 p-1"
          @click="cancel"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </button>
        <jet-button
          :class="{ 'opacity-25': form.processing }"
          :disabled="form.processing"
        >
          Save
        </jet-button>
      </div>
    </form>

    <span
      v-if="!editing"
      class="ml-4 flex-shrink-0"
    >
      <span
        v-if="recentlySuccessful"
        class="text-green-600"
      >Saved</span>
      <button
        v-else
        type="button"
        class="bg-white rounded-md font-medium text-purple-600 hover:text-purple-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500"
        @click="open"
      >
        Update
      </button>
    </span>
  </div>
</template>

<script>

import JetInputError from '../Jetstream/InputError.vue';
import JetButton from '../Jetstream/Button.vue';

export default {

  components: {
    JetButton,
    JetInputError,
  },
  props: [
    'form',
    'attribute',
    'options',
  ],

  emits: ['submitted'],
  data() {
    return {
      editing: false,
      initial_value: null,
      saved: false,
    };
  },
  computed: {
    recentlySuccessful() {
      return this.saved && this.form.recentlySuccessful;
    },
  },
  watch: {
    recentlySuccessful(val, oldVal) {
      if (val === true) {
        this.editing = false;
      }
    },
  },
  methods: {
    cancel() {
      this.form[this.attribute] = this.initial_value;
      this.initial_value = null;
      this.saved = false;
      this.editing = false;
    },
    open() {
      this.saved = false;
      this.initial_value = this.form[this.attribute];
      this.editing = true;
    },
    save() {
      this.saved = true;
      this.$emit('submitted');
      setTimeout(() => this.saved = false, 10000);
    },
  },
};
</script>
